"use client";

import React, { FC } from "react";

interface ActionButtonProps {
  children: React.ReactNode;
  handler?: () => void;
}

const ActionButton: FC<ActionButtonProps> = ({ children, handler }) => {
  return (
    <button
      onClick={
        handler
          ? async () => {
              await handler();
            }
          : () => null
      }
      className="btn btn-outline btn-accent hover:text-white"
    >
      {children}
    </button>
  );
};

export default ActionButton;
